// PaymentStatusChip — чип статуса платежа (V12 U-35): цвет + локализованная подпись (U-16).
import { Chip } from '@mui/material';
import type { PaymentStatus } from '@/api/payments';
import { formatPaymentStatus } from '@/lib/format';
import { t } from '@/i18n';

/** Цвет чипа по статусу: PENDING — warning, CONFIRMED — success (зелёный), FAILED — error. */
const STATUS_COLOR: Record<PaymentStatus, 'default' | 'warning' | 'success' | 'error'> = {
  PENDING: 'warning',
  CONFIRMED: 'success',
  FAILED: 'error',
};

/** Цвет статуса для чипов-фильтров и статус-чипов (единая палитра — DRY). */
export function paymentStatusColor(status: PaymentStatus): 'default' | 'warning' | 'success' | 'error' {
  return STATUS_COLOR[status];
}

/** MD3 Chip со статусом платежа. */
export function PaymentStatusChip({ status }: { status: PaymentStatus }): JSX.Element {
  return <Chip size="small" color={paymentStatusColor(status)} label={formatPaymentStatus(status, t)} />;
}
